import React from "react";
import { Empty, message } from "antd";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TRACKING_EVENTS } from "utils";
import { SettingsAction } from "redux/actions";
import { useDispatch } from "react-redux";
import { authRoutesUrls } from "Layouts/AuthLayout/PublicRoutes";
import { UTILS } from "utils";
import { API } from "api/";
import AuthLayout from "../../layout";
import StepsIndicator from "../../components/steps-indicator";
import Step1 from "./step-1";
import Step2 from "./step-2";
import VerifyOTP from "./verify-otp";

const DefaultStep = ()=><div className="flex justify-center items-center h-full text-center text-black text-16px"><Empty /></div>;

const checkUTMTags = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmTagsFromQuery = {};

  if (urlParams.has("utm_source")) {
    utmTagsFromQuery.utm_source = urlParams.get("utm_source");
  }
  if (urlParams.has("utm_medium")) {
    utmTagsFromQuery.utm_medium = urlParams.get("utm_medium");
  }
  if (urlParams.has("utm_campaign")) {
    utmTagsFromQuery.utm_campaign = urlParams.get("utm_campaign");
  }

  if (Object.keys(utmTagsFromQuery)?.length === 0) {
    const cookies = document.cookie?.split(";");
    cookies?.forEach((cookie) => {
      const [name, value] = cookie?.trim()?.split("=");
      if (
        name === "utm_source" ||
        name === "utm_medium" ||
        name === "utm_campaign"
      ) {
        utmTagsFromQuery[name] = value || "";
      }
    });
  }

  return utmTagsFromQuery;
};

export const steps = {
  1: {
    key: 1,
    content:"What Service Type of website should this be?",
    Component: Step1,
    title:"Choose your service type",
  },
  2: {
    key: 2,
    content:"Who will be using this account?",
    Component: Step2,
    title: "Register your account"
  } ,
  3: {
    key: 3,
    content:"We have sent a verification code to your mobile number",
    title: "Enter Verification Code ",
    Component: VerifyOTP,
  }
};


const AccountRegistration = () => {
  const { t, i18n } = useTranslation();
  const [currentStepInfo, setCurrentStepInfo] = React.useState(steps[1]);
  const [loading, setLoading] = React.useState(false);

  const history = useHistory();
  const dispatch = useDispatch();

  const [stepData, setStepData] = React.useState({});

  const onNextStep = (key, data) => {
    console.log({key, data})
    setStepData((prev)=>({
      ...prev,
      [key]: data,
    }));
    const nextStep = currentStepInfo.key + 1;
    setCurrentStepInfo(steps[nextStep]);
  }

  const goToVerifyPage = async (data) => {
    history.push(authRoutesUrls.verify, {
      stateRegister:
      {
        values:{
          ...data,
        }
      }
    });
  };

  const handleSubmit = async (data) => {
    setLoading(true);
    if (data.phoneNumber.charAt(4) === "0") {
      data.phoneNumber =
        data.phoneNumber.slice(0, 4) +
        data.phoneNumber.slice(5);
    }

    const utmTags = checkUTMTags();
    const utmSource = utmTags.utm_source;
    const utmMedium = utmTags.utm_medium;
    const utmCampaign = utmTags.utmCampaign;

    const result = await API.REGISTER({
      brandName: data.brandName,
      name: data.name,
      email: data.email.trim(),
      phoneNumber: data.phoneNumber,
      password: data.password,
      superCategoryId: stepData.serviceType,
      baseLanguage: i18n.language || "en",
      language: i18n.language === "en" ? "EN" : "AR",
      utmSource,
      utmMedium,
      utmCampaign,
    });

    if (result?.response === 200 && result?.success) {
      UTILS.saveCurrentUser({
        name: result.data.user.userName,
        email: result.data.user.email,
        phoneNumber: result.data.user.phoneNumber,
        token: null,
        storeFrontURL: result.data.storeFrontURL,
        storePreviewURL: result.data.storePreviewURL,
        brandId: result.data.user.brandId._id,
        userId: result.data.user.userId,
        userType: result?.data?.user?.userType,
        brandName: result.data.user.brandId.brandName,
        subscribedPackage: result.data.subscribedPackage?.packageId
          ? result.data.subscribedPackage?.packageId
          : "",
        catalogueType: result?.data?.user?.brandId?.catalogueType,
        temporaryDomainName: result?.data?.brandSettings?.temporaryDomainName,
      });
      TRACKING_EVENTS.nonVerifiedRegistrations({
        userId: result.data.user.userId,
        brandName: data.brandName,
        phoneNumber: data.phoneNumber,
      });
      dispatch(
        SettingsAction.updateCatalogueType(
          result?.data?.user?.brandId?.catalogueType
        )
      );
      const obj = {
        direction: UTILS.getLayoutDirection(data.baseLanguage),
        lang: data.baseLanguage,
      };
      UTILS.saveLanguageInformation(obj);
      goToVerifyPage({
        ...stepData,
        ...data,
      });
      UTILS.checkPackageValidity();
    } else {
       message.error(result.message);
    }
    setLoading(false);
  };

  return (
    <AuthLayout
      loading={loading}
      title={t(currentStepInfo.title)}
      description={t(currentStepInfo.content)}
      onBackButtonClick={currentStepInfo.key > 1 ? () => setCurrentStepInfo(steps[currentStepInfo.key - 1]) : undefined}
      leftExtraContent={
        <StepsIndicator
          currentStep={currentStepInfo.key}
          content={currentStepInfo.content}
          totalSteps={Object?.keys(steps)?.length}
        />
      }
    >
      {currentStepInfo.Component ? <currentStepInfo.Component onNextStep={onNextStep} onSubmit={handleSubmit} /> : <DefaultStep />}
    </AuthLayout>
  );
};

export default AccountRegistration;
